/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type DeliverObjectCriticality =
  (typeof DeliverObjectCriticality)[keyof typeof DeliverObjectCriticality];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliverObjectCriticality = {
  EASY: "EASY",
  MIDDLE: "MIDDLE",
  HIGH: "HIGH",
} as const;
